import { render } from "./ProfitReport.vue?vue&type=template&id=60707cc4"
import script from "./ProfitReport.vue?vue&type=script&lang=js"
export * from "./ProfitReport.vue?vue&type=script&lang=js"

import "./ProfitReport.vue?vue&type=style&index=0&id=60707cc4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__